import { salesPerson } from './../../../../model/masters.model';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../../loader/loader.component';
import { Product, RecentInteractions, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { SalesService } from '../../../../services/sales.service';
import { CustomerService } from '../../../../services/customer.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UnitsOfMeasure, Warehouse } from '../../../../model/administration.model';
import { SalespersonLookupComponent } from '../../../Lookup/salesperson-lookup/salesperson-lookup.component';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import _ from 'lodash';
import { ShipToCustomerLookupComponent } from '../../../Lookup/shiptocustomer-lookup/shiptocustomer-lookup.component';
import { BillToCustomerLookupComponent } from '../../../Lookup/billtocustomer-lookup/billtocustomer-lookup.component';
import { InventoryService } from '../../../../services/inventory.service';
import { CloseQuickProductLookupComponent } from '../../../Lookup/close-quick-product-lookup/close-quick-product-lookup.component';
import { UOMLookupComponent } from '../../../Lookup/uomlookup/uomlookup.component';
import { MultiProductDescriptionLookupComponent } from '../../../Lookup/multi-product-description-lookup/multi-product-description-lookup.component';
import { ListLinkedFilesLookupComponent } from '../../../Lookup/List-Linked-Files-lookup/list-linked-files.lookup.component';
import { POCommentsLookupComponent } from '../../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { CloseQuickCustomerLookupComponent } from '../../../Lookup/close-quick-customer-lookup/close-quick-customer-lookup.component';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { PaymentReceiptService } from '../../../../services/payment-receipt.service';
import { viewproductLookupComponent } from '../../../Lookup/viewproduct-lookup/viewproduct-lookup.component';
import { getISTDateWithCurrentTime } from '../../../../utils/date-utils';
import { ReportCenterService } from '../../../../services/report-center.service';
import { catchError, firstValueFrom, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { formatDateDDMMYY } from '../../../../services/formatDateDDMMYY';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { discountAmountFromPercent, netFromAmountAndPercent, round2 } from '../../../../shared/discount-percent.util';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';

@Component({
  selector: 'app-create-order',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-order.component.html',
  styleUrl: './create-order.component.scss'
})
export class CreateOrderComponent implements OnInit {
  @ViewChild('productCodeInputRef') productCodeInputRef!: any;
  userList: any;
  productCostCalculationType: string | undefined;
  productId: any;
  constructor(private router: Router, private messageService: MessageService, private customerService: CustomerService, private administratorService: AdministratorService,
    public dialogService: DialogService, private inventoryService: InventoryService, public ref: DynamicDialogRef, private salesService: SalesService, private el: ElementRef, private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private paymentService: PaymentReceiptService, private reportService: ReportCenterService, private emailTemplateService: EmailTemplateService, private porderservice: PurchaseorderService
  ) { }

  quoation: boolean = false;
  loader: boolean = false;
  isEdit: boolean = false;
  isIGST: boolean = false;
  submitted: boolean = false;
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  deliveryDate: any | undefined;
  QAvail: number = 0;
  isQAvailWarning: boolean = false;
  unitLabel: string = '';
  selectedOrder: SalesOrder[] = [];
  companyInfo: any = {};
  ReportPath: any;
  activeIndex: number = 0;
  previewImage: string = "./assets/no-image.jpg";
  Data: any;
  savePopupVisible: boolean = false;
  customerEmail: any;
  Status: any;
  ShipmentDate: any;
  outstandingReceivables: number = 0;
  canSendEmail: boolean = false;
  isOpenStatus: boolean = false;
  showRCM: boolean = false;
  canEdit: any;

  statusDropdown = [
    { label: 'Draft - 0%', value: 'Draft - 0%' },
    { label: 'Confirmed - 20%', value: 'Confirmed - 20%' },
    { label: 'Processing - 40%', value: 'Processing - 40%' },
    { label: 'Released to Fulfillment - 60%', value: 'Released to Fulfillment - 60%' }
  ];

  createOrderForm = new FormGroup({
    OrderNo: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    BillToCustomerId: new FormControl('', Validators.required),
    ShipToCustomerId: new FormControl('', Validators.required),
    BillToCustomerCode: new FormControl('', Validators.required),
    ShipToCustomerCode: new FormControl('', Validators.required),
    BillToCustomer: new FormControl('', Validators.required),
    ShipToCustomer: new FormControl('', Validators.required),
    BillToCustomerAddress: new FormControl(''),
    ShipToCustomerAddress: new FormControl('', Validators.required),
    warehouse: new FormControl('', Validators.required),
    WareHouseId: new FormControl('', Validators.required),
    SalespersonCode: new FormControl('', Validators.required),
    SalespersonId: new FormControl('', Validators.required),
    salesperson: new FormControl('', Validators.required),
    CreatedBy: new FormControl('', Validators.required),
    // add product
    totalWeight: new FormControl(),
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productWgt: new FormControl(''),
    productData: new FormControl(''),
    ShipmentDate: new FormControl(),
    TermsCode: new FormControl(''),
    PaymentTermsId: new FormControl(),
    purchaseOrderNumber: new FormControl(),
    LRRRNo: new FormControl(),
    BillOfLading: new FormControl(),
    DispatchDocNo: new FormControl(''),
    MotorVehicalNo: new FormControl(),
    DispatchThrough: new FormControl(),
    // OrderType: new FormControl('Q'),

    BillToCustomerState: new FormControl(''),
    warehouseState: new FormControl(''),
    warehouseStateCode: new FormControl(''),
    requestedDate: new FormControl<Date | null>(null, Validators.required),
    orderDate: new FormControl<Date | null>(null, Validators.required),
    deliveryNote: new FormControl(''),

    ReferenceNumber: new FormControl(),
    Destination: new FormControl(),
    TermsOfDelivery: new FormControl(),
    CustomerPODate: new FormControl(),
    Status: new FormControl(),
    RateOnFreight: new FormControl(),
    DiscountAmount: new FormControl(0),
    FreightTotal: new FormControl(),
    GSTOnFreight: new FormControl(),
    FinalTaxableAmt: new FormControl(),
    supplyType: new FormControl('', Validators.required),

    isLUT: new FormControl(false),
    expTyp: new FormControl(''),
    isRCM: new FormControl(false),
    POS: new FormControl(''),
    POSDisplay: new FormControl(''),
    BillToCustomerStateCode: new FormControl(''),
    ShipToCustomerStateCode: new FormControl(''),
    ShipToCustomerState: new FormControl(''),
    FinancialYearId: new FormControl(),
    projectBoMId: new FormControl(null),
    projectName: new FormControl(''),
    projectNo: new FormControl(''),
  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  readonlyFields: { [key: string]: boolean } = {};
  BillTocustomerList: any[] = [];
  ShipTocustomerList: any[] = [];
  warehouseDropdown: Warehouse[] = [];
  filterWarehouses: Warehouse[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];    // Main product variable
  allProductData: Product[] = []; // Stores all product data even after deleting from the grid
  addProductData: any;        // Represents data for adding a new product
  selectedProduct: Product[] = [];   // // Stores data for deleted products
  deleteProductIds: any[] = [];
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  autoSendEmail: boolean = false;

  orderTotal: number = 0.00;
  weightTotal: number = 0.00;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  Taxable: number = 0.00;
  FinalTaxableAmt: number = 0.00;
  NonTaxableTotal: number = 0.00;

  items: MenuItem[] | undefined;

  ngOnInit(): void {
    document.title = 'Create Order';
    this.route.queryParams.subscribe(params => {
      if (params['Data']) {
        this.isEdit = true;
        document.title = 'Update Order';
        this.reOpen();
      } else {
        this.isEdit = false;
        this.resetForms();
        this.manualEntry();

        this.subscribeFinancialYearChanges();

        const currentDate = new Date();
        this.createOrderForm.controls.requestedDate.setValue(currentDate);
        this.createOrderForm.controls.orderDate.setValue(currentDate);
      }
    });
    this.getWarehouse();
    this.getUserList();
    this.createOrderForm.patchValue({ Status: 'Draft - 0%' });
    this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    //this.createOrderForm.controls.orderDate.setValue(new Date());
    const currentDate = new Date();
    //this.createOrderForm.controls.requestedDate.setValue(currentDate);
    this.deliveryDate = currentDate;
    this.items = [
      { label: 'Quote' },
      { label: 'Order' },
    ];
    this.getSystemConfigData();
    this.getCompanyDetails();

    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
    this.createOrderForm.get('DiscountAmount')?.valueChanges.subscribe((value) => {
      const discountVal = Number(value) || 0;
      if (discountVal > 0) {
        this.products.forEach(p => p.Discount = 0);
      }
      this.calculateOrderTotal();
    });

    this.createOrderForm.get('GSTOnFreight')?.valueChanges.subscribe(() => {
      this.calculateOrderTotal();
    });

    this.createOrderForm.get('RateOnFreight')?.valueChanges.subscribe(() => {
      this.calculateFreightGST();
    });

    this.createOrderForm.get('FreightTotal')?.valueChanges.subscribe(() => {
      this.calculateFreightGST();
    });

    this.setupFormSubscriptions();

  }

  private subscribeFinancialYearChanges() {

    this.createOrderForm.get('orderDate')?.valueChanges.subscribe(date => {
      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Order");
      }
    });

    this.createOrderForm.get('requestedDate')?.valueChanges.subscribe(date => {
      if (date instanceof Date) {
        this.onTransactionDateChange(date, "requested");
      }
    });

  }

  private subscriptions: Subscription[] = [];

  setupFormSubscriptions() {

    const form = this.createOrderForm;

    // 🔥 All fields that affect GST / Tax logic
    const taxTriggers = [
      'supplyType',
      'isLUT',
      'isRCM',
      'BillToCustomerState',
      'ShipToCustomerState',
      'warehouseState'
    ];

    taxTriggers.forEach(field => {

      const sub = form.get(field)?.valueChanges
        .pipe(debounceTime(100)) // 🔥 prevents multiple rapid triggers
        .subscribe(() => {

          const value = form.value;

          // 🔥 Reset LUT + Export Type if not EXPORT/SEZ
          if (field === 'supplyType' &&
            value.supplyType !== 'EXPORT' &&
            value.supplyType !== 'SEZ') {

            form.patchValue({
              isLUT: false,
              expTyp: ''
            }, { emitEvent: false });
          }

          // 🔥 NEW: POS
          this.setPlaceOfSupply();

          // 🔥 Central business rules
          this.setExportType();
          //this.validateRCM();
          if (field === 'supplyType') {

            this.updateRCMState(value.supplyType ?? '');

            this.validateRCM();
          }


          // 🔥 Single calculation point
          this.calculateOrderTotal();
        });

      if (sub) this.subscriptions.push(sub);
    });


  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getUserList(): void {
    if (this.isEdit) {
      return;
    }
    this.loader = true;
    this.administratorService.getAllUser().subscribe({
      next: (data: any) => {
        this.userList = data;
        this.setWarehouseFromSession();
        this.loader = false;
      },
      error: error => {
        console.error('Error fetching user info:', error);
        this.loader = false;
      }
    });
  }

  setWarehouseFromSession(): void {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData.user?.id;

    const user = this.userList.find((u: { userId: number; warehouseId?: number }) => u.userId === userId);
    if (user) {
      const warehouseId = user.warehouseId;
      if (warehouseId) {
        this.createOrderForm.controls.WareHouseId.setValue(warehouseId);
        this.setWarehouseName(warehouseId);
      } else {
        console.warn(`No warehouse ID found for user ID: ${userId}`);
      }
    } else {
      console.warn(`User not found with user ID: ${userId}`);
    }
  }

  setWarehouseName(warehouseId: number): void {
    const warehouse = this.warehouseDropdown.find(w => w.warehouseId === warehouseId);
    if (warehouse) {
      this.createOrderForm.controls.warehouse.setValue(warehouse.warehouseName);
      this.createOrderForm.controls.warehouseState.setValue(warehouse.address.state);
    }
  }

  resetForms() {
    this.createOrderForm.reset();
    this.createOrderForm.controls.manualEntry.setValue(false);
    this.orderTotal = 0;
    this.weightTotal = 0;
    this.CGSTtotal = 0;
    this.SGSTtotal = 0;
    this.IGSTtotal = 0;
    this.isIGST = false;
    this.products = [];
    this.allProductData = [];
    this.calculateOrderTotal();
  }

  get formControls() {
    return this.createOrderForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createOrderForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  resetForm() {

    this.confirmationService.confirm({
      header: 'Reset',
      message: 'Reset will permanently delete all lines in the Order Line.',
      accept: () => {

        var selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);

        this.loader = true;
        this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
          next: async (data: any) => {
            if (data) {
              this.products = this.products.filter(product => !selectedProductIds.includes(product.SalesOrderLineItemId));
              this.selectedProduct = [];
              const isValid = this.calculateOrderTotal();
              if (await isValid) {
                this.createSalesOrder('TEMP.ORDER');
              }
            }
          },
          error: error => {
            console.log(error);
            this.loader = false;
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while reset' });
          }
        });

      },
      reject: () => {
      }
    });

  }

  Cancel() {
    // if(this.isEdit){
    this.router.navigate(['/home/listOrder']);
    // }else{
    //   this.router.navigate(['/home']);
    // }
  }

  manualEntry() {
    const manualEntryValue = this.createOrderForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.createOrderForm.controls.OrderNo.setValue('');
    } else {
      this.getOrderNumber();
    }

  }

  getOrderNumber() {
    this.loader = true;

    this.salesService.autogenerateOrderNumber().subscribe({
      next: (data: any) => {
        this.createOrderForm.controls.OrderNo.setValue(data.fullNumber);
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      }
    });
  }

  checkOrderNumber() {
    if (!this.createOrderForm.controls.OrderNo.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.salesService.checkOrderNumber(this.createOrderForm.controls.OrderNo.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.createOrderForm.controls.OrderNo.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Order number already exists.' });
            this.createOrderForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  async validateSalesOrder(value: string, sendEmail: boolean = false) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    for (const product of this.products) {
      const validProductId = product.ProductId || this.productId;
      try {
        const productData = await this.getProductById(validProductId);
        const costCalculationType = productData.costCalculation || 'Qty';

        if (costCalculationType === 'Qty' && product.OrderQuantity <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'OrderQuantity must be greater than 0.' });
          return;
        }

        if (costCalculationType === 'Wgt' && product.Weight <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
          return;
        }

        if (!product.ProductDescription) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Product Name is Required' });
          return;
        }
      } catch (error) {
        console.error('Failed to fetch product data:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to fetch product details.' });
        return;
      }
    }

    this.createSalesOrder(value, false, sendEmail);
  }

  showBillToCustomerDialog() {
    const ref = this.dialogService.open(BillToCustomerLookupComponent, {
      header: 'Bill TO Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {

      if (selectedCustomer) {

        this.applyBillToCustomer(selectedCustomer);

      }
    });
  }


  getTermsByCustomer(CustomerCode: string) {
    this.paymentService.getTermByCustomer(CustomerCode).subscribe(
      (data: any) => {
        if (data.success) {
          const termsData = data.termsDetails
          this.createOrderForm.controls.TermsCode.setValue(termsData.paymentTermsDescription),
            this.createOrderForm.controls.PaymentTermsId.setValue(termsData.paymentTermsId)

        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while patch customer' });
      }
    );
  }

  openShipToCustomerLookup() {
    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.createOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
        this.createOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
        this.createOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
        const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
        this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
      }
    });
  }

  autosearchBilltoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.BillTocustomerList = data.filter((customer: any) => customer.isActive === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setBillTo(data: any) {

    const customer = data?.value;

    this.applyBillToCustomer(customer);
  }

  applyBillToCustomer(customer: any) {

    if (!customer) return;

    const addressObj = customer.address || {};

    const address = `${addressObj.addressLine1}, ${addressObj.city},${addressObj.state}, ${addressObj.country},${addressObj.zip}`;

    //console.log(address);

    this.createOrderForm.patchValue({

      BillToCustomerCode: customer.customerCode,
      BillToCustomer: customer.customerName,
      BillToCustomerId: customer.customerId,
      BillToCustomerAddress: address,

      BillToCustomerState: addressObj.state || '',
      BillToCustomerStateCode: addressObj.stateCode || ''
    });

    this.customerEmail = customer.email;
    this.selectedCustomerEmail = customer.email;
    this.selectedCustomerName = customer.customerName;

    this.loadOutstandingAmount(customer.customerId);
    this.getTermsByCustomer(customer.customerCode);

    if (customer.isShipToCustomer) {

      this.createOrderForm.patchValue({

        ShipToCustomerCode: customer.customerCode,
        ShipToCustomer: customer.customerName,
        ShipToCustomerId: customer.customerId,
        ShipToCustomerAddress: address,

        ShipToCustomerState: addressObj.state || '',
        ShipToCustomerStateCode: addressObj.stateCode || ''
      });
    }

    // GST Logic
    const supplyType = this.getSupplyType(customer);

    this.createOrderForm.patchValue({
      supplyType: supplyType
    });

    this.setExportType();
    this.updateRCMState(supplyType);
    this.setPlaceOfSupply();

    setTimeout(() => {
      this.calculateOrderTotal();
    });
  }

  loadOutstandingAmount(customerId: number): void {
    if (!customerId) return;

    this.customerService.getOutstandingAmount(customerId.toString())
      .subscribe({
        next: (amount: number) => {
          this.outstandingReceivables = amount;
        },
        error: err => {
          console.error('Outstanding amount error', err);
          this.outstandingReceivables = 0;
        }
      });
  }

  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true && customer.isActive === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setShipTo(data: any) {
    if (data.value) {
      this.createOrderForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.createOrderForm.controls.ShipToCustomer.setValue(data.value.customerName);
      this.createOrderForm.controls.ShipToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
    }
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
        // console.log(data);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouse = (this.warehouseDropdown as any[])[i];
      if (warehouse.warehouseName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        warehouse.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(warehouse);
      }
    }

    this.filterWarehouses = filtered;
  }

  // setWarehouse(data: any) {
  //   if (data.value) {
  //     this.createOrderForm.controls.WareHouseId.setValue(data.value.warehouseId);
  //     this.createOrderForm.controls.warehouseState.setValue(data.value.address.state);
  //   }
  // }

  setWarehouse(data: any) {

    const warehouse = data?.value;

    if (!warehouse) return;

    this.createOrderForm.patchValue({
      WareHouseId: warehouse.warehouseId,
      warehouseState: warehouse.address?.state || '',
      warehouseStateCode: warehouse.address?.stateCode || ''
    });

    // Recalculate POS and GST
    this.setPlaceOfSupply();
    this.calculateOrderTotal();
  }

  showSalesperson() {
    if (this.products.length > 0) {
      return;
    }

    this.ref = this.dialogService.open(SalespersonLookupComponent, {
      header: 'Salesperson List',
      width: '60%',

    });
    this.ref.onClose.subscribe((data: salesPerson) => {
      if (data) {
        this.createOrderForm.controls.SalespersonCode.setValue(data.salespersonCode);
        this.createOrderForm.controls.SalespersonId.setValue(_.toString(data.salespersonId));
        this.createOrderForm.controls.salesperson.setValue(data.salespersonName);
      }
    });
  }

  showTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '60%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createOrderForm.patchValue({
          TermsCode: data.paymentTermsDescription,
          PaymentTermsId: data.paymentTermsId
        })
      }
    })
  }


  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  async setProduct(data: any) {
    this.createOrderForm.controls.productCode.setValue(data.value.productCode);
    this.createOrderForm.controls.productDescription.setValue(data.value.productName);
    this.createOrderForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;
    const costCalculationType = data.value.costCalculation || 'Qty';
    this.productCostCalculationType = costCalculationType;
    if (costCalculationType === 'Qty') {
      this.createOrderForm.controls.productQty.setValue('');
    } else if (costCalculationType === 'Wgt') {
      this.createOrderForm.controls.productWgt.setValue('');
    }
    this.setFieldFocus();

    if (data.value.productImage) {
      this.previewImage = `data:image/jpeg;base64,${data.value.productImage}`;
    } else {
      this.previewImage = "./assets/no-image.jpg";
    }
    this.getInventoryStatus(data.value.productCode);
  }


  setFieldFocus() {
    const control = this.el.nativeElement.querySelector('#Qty');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }



  validateCustomer() {
    let isValid = true;

    if (
      !this.createOrderForm.controls.BillToCustomer?.valid ||
      !this.createOrderForm.controls.ShipToCustomer?.valid ||
      !this.createOrderForm.controls.warehouse?.valid ||
      !this.createOrderForm.controls.SalespersonCode?.valid ||
      !this.createOrderForm.controls.OrderNo?.valid ||
      !this.createOrderForm.controls.BillToCustomer?.valid ||
      !this.createOrderForm.controls.ShipToCustomer?.valid ||
      !this.createOrderForm.controls.WareHouseId?.valid

    ) {
      if (!this.createOrderForm.controls.BillToCustomer.value) {
        this.createOrderForm.controls.BillToCustomerCode.setValue('');
      } else if (!this.createOrderForm.controls.ShipToCustomer.value) {
        this.createOrderForm.controls.ShipToCustomerCode.setValue('');
      } else if (!this.createOrderForm.controls.WareHouseId.value) {
        this.createOrderForm.controls.warehouse.setValue('');
      }
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  async checkIGST() {

    this.isIGST = this.isIGSTApplicable();

  }

  onSavePopupHide() {
    this.savePopupVisible = false;
  }

  showSaveOptionsPopup() {
    if (this.autoSendEmail) {
      this.savePopupVisible = true;
    } else {
      if (this.isEdit) {
        this.update(false, false);
      } else {
        this.validateSalesOrder('ORDER', false);
      }
    }
  }

  saveOnly() {
    this.savePopupVisible = false;
    if (this.isEdit) {
      this.update(false, false);
    } else {
      this.validateSalesOrder('ORDER', false);
    }
  }

  saveAndSend() {
    this.savePopupVisible = false;
    if (this.isEdit) {
      this.update(false, true);
    } else {
      this.validateSalesOrder('ORDER', true);
    }
  }


  openSavePopup() {
    this.confirmationService.confirm({
      message: 'Choose an action:',
      header: 'Save Options',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Save',
      rejectLabel: 'Save & Send',
      acceptButtonStyleClass: 'p-button-info',
      rejectButtonStyleClass: 'p-button-success',

      accept: () => {
        // Only Save
        this.validateSalesOrder('ORDER', false);
      },

      reject: () => {
        // Save + Send email
        this.validateSalesOrder('ORDER', true);
      }
    });
  }


  // Function to add a product to the quote
  async addProduct() {
    if (!this.validateFinancialYear()) {
      return;
    }

    this.submitted = true;
    const orderQuantity = _.toNumber(this.createOrderForm.controls.productWgt.value);

    if (this.isQAvailWarning) {
      if (orderQuantity > this.QAvail) {
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Product Qty not available.' });
        return;
      }
    }

    const { requestedDate: requestedDateValue, orderDate: orderDateValue } = this.createOrderForm.controls;
    if (requestedDateValue?.value && orderDateValue?.value) {
      const requestedDate = new Date(requestedDateValue.value);
      const orderDate = new Date(orderDateValue.value);
      requestedDate.setHours(0, 0, 0, 0);
      orderDate.setHours(0, 0, 0, 0);

      if (requestedDate < orderDate) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Date Range',
          detail: 'The requested date cannot be earlier than the order date.'
        });
        return;
      }
    }

    this.loader = true;
    await this.checkIGST();

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      this.loader = false;
      return;
    }

    const productId = _.toNumber(this.createOrderForm.controls.productId.value);
    let costCalculationType: string;

    this.inventoryService.getProductById(productId).subscribe({
      next: (productData) => {
        if (!productData) {
          console.error('Product data is empty');
          this.loader = false;
          return;
        }

        this.addProductData = {
          ...this.addProductData,
          productName: productData.productName || this.addProductData.productName,
          standardCost: productData.standardCost || this.addProductData.standardCost,
          productCode: productData.productCode || this.addProductData.productCode,
          hsnCode: productData.hsnCode || this.addProductData.hsnCode,
          gst: productData.gstRate || this.addProductData.gstRate,
          productSpecification: productData.productSpecification,
          isServiceType: productData.isServiceType,
        };
        costCalculationType = productData?.costCalculation || 'Qty';

        const lastItem = this.allProductData[this.allProductData.length - 1];
        const weight = _.toNumber(this.createOrderForm.controls.productWgt.value);
        const parseCurrency = (value: any): number => {
          return parseFloat((value ?? 0).toString().replace(/[₹,]/g, ''));
        };
        const salesPrice = parseCurrency(this.addProductData?.salesPrice);
        const standardCost = parseCurrency(this.addProductData?.standardCost);
        const deliveryDate = (this.createOrderForm.controls.requestedDate.value);

        let extensionPrice: number;

        if (costCalculationType === 'Qty') {
          extensionPrice = orderQuantity * salesPrice;
        } else if (costCalculationType === 'Wgt') {
          extensionPrice = weight * salesPrice;
        } else {
          console.warn('Unknown costCalculation type:', costCalculationType);
          extensionPrice = 0;
        }

        const formatCurrency = (value: number | bigint) => {
          return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(value);
        };
        const gstRate = this.addProductData.gst != null ? this.addProductData.gst : 0;
        const product: Product = <Product><unknown>{
          SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
          ProductId: productId,
          OrderQuantity: costCalculationType === 'Wgt' ? 0 : orderQuantity,
          Uom: _.toString(this.addProductData.sellingUom),
          LineItemNumber: (this.allProductData.length !== 0) ? lastItem.LineItemNumber + 1 : 1,
          IsTaxable: this.addProductData.isTaxable,
          StandardCost: standardCost,
          UnitPrice: salesPrice,
          ExtensionPrice: extensionPrice,
          Comment: "",
          deliveryDate: deliveryDate,
          GSTRate: gstRate,
          HSNCode: this.addProductData.hsnCode,
          Discount: 0,
          DiscountAmount: 0,
          NetAmount: _.round(extensionPrice, 2),
          CGST: (!this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable) / 2 : 0,
          SGST: (!this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable) / 2 : 0,
          IGST: (this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable) : 0,
          SalesTax: this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable),
          LineTotal: _.round(extensionPrice + this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable), 2),
          Weight: costCalculationType === 'Qty' ? 0 : weight,
          WareHouseId: _.toNumber(this.createOrderForm.controls.WareHouseId.value),
          ProductCode: this.addProductData.productCode,
          ProductDescription: this.addProductData.productName,
          ProductSpecification: this.addProductData.productSpecification,
          CreatedBy: _.toString(this.createOrderForm.controls.CreatedBy.value),
          IsActive: true,
          DepartmentId: 0,
          LocationId: 0,
          SerialId: 0,
          VendnorId: 0,
          IsServiceType: this.addProductData.isServiceType,
        }


        if (this.isEdit) {
          this.products.push(product);
          this.createOrderForm.controls.productCode.setValue('');
          this.createOrderForm.controls.productDescription.setValue('');
          this.createOrderForm.controls.productQty.setValue('');
          this.createOrderForm.controls.productWgt.setValue('');
          this.previewImage = "./assets/no-image.jpg";
          this.loader = false;
          this.calculateOrderTotal();
          this.allProductData.push(product);
        } else {
          this.previewImage = "./assets/no-image.jpg";
          // Call the function to create an invoice line item
          this.createSalesOrderLineItem(product);
        }

        this.QAvail = 0;
        setTimeout(() => {
          const inputEl: HTMLInputElement = this.productCodeInputRef?.el?.nativeElement?.querySelector('input');
          inputEl?.focus();
        }, 0);
      }

    });
  }
  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(this.productId || productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  // Function to create a sales order line item in the database
  createSalesOrderLineItem(product: Product) {
    this.salesService.createSalesOrderLineItem(product).subscribe(
      async (data: any) => {
        if (data) {
          // console.log(data);
          product.SalesOrderLineItemId = data.lineItemId;
          this.products.push(product);
          this.createOrderForm.controls.productCode.setValue('');
          this.createOrderForm.controls.productDescription.setValue('')
          this.createOrderForm.controls.productQty.setValue('')
          this.createOrderForm.controls.productWgt.setValue('')
          this.loader = false;
          const isValid = this.calculateOrderTotal();
          // Create a sales order with a temporary status
          if (await isValid) {
            this.createSalesOrder('TEMP.ORDER');
          }
          this.allProductData.push(product);
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while adding product' });
      }
    );
  }
  gstOptions = [
    { label: 'GST0 - (0%)', value: 0 },
    { label: 'GST5 - (5%)', value: 5 },
    { label: 'GST12 - (12%)', value: 12 },
    { label: 'GST18 - (18%)', value: 18 },
    { label: 'GST28 - (28%)', value: 28 }
  ];
  calculateFreightGST() {

    const freight = Number(this.createOrderForm.get('FreightTotal')?.value) || 0;
    const rate = Number(this.createOrderForm.get('RateOnFreight')?.value) || 0;

    const gstAmount = (freight * rate) / 100;

    this.createOrderForm.patchValue({
      GSTOnFreight: Number(gstAmount.toFixed(2))
    }, { emitEvent: false });

    this.calculateOrderTotal();
  }
  // Function to create a sales order
  createSalesOrder(value: string, MoveToShipping: boolean = false, sendEmail: boolean = false) {

    const SalesOrder: Partial<SalesOrder> = {
      SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
      OrderType: "ORDERTYPE.NORMAL",
      SalesOrderStatus: (this.isEdit) ? 'ORDER' : value,
      SalesOrderDate: new Date(),
      // ShipmentDate: this.createOrderForm.controls.ShipmentDate.value,
      SalespersonId: this.createOrderForm.controls.SalespersonId.value ?? undefined,
      SalespersonCode: this.createOrderForm.controls.SalespersonCode.value ?? undefined,
      CustomerId: this.createOrderForm.controls.BillToCustomerId.value ?? undefined,
      BillToCustomerCode: this.createOrderForm.controls.BillToCustomerCode.value ?? undefined,
      BillToCustomerId: this.createOrderForm.controls.BillToCustomerId.value ?? undefined,
      ShipToCustomerCode: this.createOrderForm.controls.ShipToCustomerCode.value ?? undefined,
      ShipToCustomerId: this.createOrderForm.controls.ShipToCustomerId.value ?? undefined,
      WarehouseId: this.createOrderForm.controls.WareHouseId.value ?? undefined,
      OrderTotal: this.orderTotal,
      CGSTTotal: this.CGSTtotal,
      SGSTTotal: this.SGSTtotal,
      IGSTTotal: this.IGSTtotal,
      totalWeight: this.weightTotal,
      SalesTaxTotal: this.CGSTtotal + this.CGSTtotal + this.IGSTtotal,
      IsActive: true,
      CreatedBy: this.createOrderForm.controls.CreatedBy.value ?? undefined,
      MotorVehicleNo: this.createOrderForm.controls.MotorVehicalNo.value ?? undefined,
      TermsCode: this.createOrderForm.controls.TermsCode.value ?? undefined,
      PaymentTermsId: this.createOrderForm.controls.PaymentTermsId.value ?? undefined,
      DispatchDocNo: this.createOrderForm.controls.DispatchDocNo.value ?? undefined,
      deliveryNote: this.createOrderForm.controls.deliveryNote.value ?? undefined,
      BillOfLading: this.createOrderForm.controls.BillOfLading.value ?? undefined,
      PurchaseOrderNumber: this.createOrderForm.controls.purchaseOrderNumber.value ?? undefined,
      LRRRNo: this.createOrderForm.controls.LRRRNo.value ?? undefined,
      DispatchThrough: this.createOrderForm.controls.DispatchThrough.value ?? undefined,
      BackOrderTotal: 0,
      MarginTotal: 0,
      ProfitTotal: 0,
      LabourTotal: 0,
      // FreightTotal: 0,
      orderDate: this.createOrderForm.controls.orderDate.value ?? undefined,
      requestedDate: this.createOrderForm.controls.requestedDate.value ?? undefined,

      ReferenceNumber: this.createOrderForm.controls.ReferenceNumber.value ?? undefined,
      Destination: this.createOrderForm.controls.Destination.value ?? undefined,
      TermsOfDelivery: this.createOrderForm.controls.TermsOfDelivery.value ?? undefined,
      CustomerPODate: this.createOrderForm.controls.CustomerPODate.value ?? undefined,
      Status: this.createOrderForm.controls.Status.value ?? undefined,
      RateOnFreight: this.createOrderForm.controls.RateOnFreight.value || 0,
      DiscountAmount: this.createOrderForm.controls.DiscountAmount.value || 0,
      FreightTotal: this.createOrderForm.controls.FreightTotal.value || 0,
      GSTOnFreight: this.createOrderForm.controls.GSTOnFreight.value || 0,
      FinalTaxableAmt: this.createOrderForm.controls.FinalTaxableAmt.value || 0,
      SupplyType: this.createOrderForm.controls.supplyType.value ?? undefined,
      IsLUT: this.createOrderForm.controls.isLUT.value ?? undefined,
      ExportType: this.createOrderForm.controls.expTyp.value ?? undefined,
      IsRCM: this.createOrderForm.controls.isRCM.value ?? undefined,
      POS: this.createOrderForm.controls.POS.value ?? undefined,
      projectBoMId: this.createOrderForm.controls.projectBoMId.value ?? undefined,
      projectName: this.createOrderForm.controls.projectName.value ?? undefined,
      projectNo: this.createOrderForm.controls.projectNo.value ?? undefined,
      FinancialYearId: Number(this.createOrderForm.controls['FinancialYearId'].value)
    };



    if (this.createOrderForm.controls.ShipmentDate.value) {
      // SalesOrder.ShipmentDate = this.createOrderForm.controls.ShipmentDate.value;
      var ShipmentDate = this.createOrderForm.controls.ShipmentDate.value;
      const currentTime = new Date();
      ShipmentDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.ShipmentDate = ShipmentDate;
    }

    if (this.createOrderForm.controls.orderDate.value) {
      var orderDate = this.createOrderForm.controls.orderDate.value;
      const currentTime = new Date();
      orderDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.orderDate = orderDate;
    }

    if (this.createOrderForm.controls.requestedDate.value) {
      var requestedDate = this.createOrderForm.controls.requestedDate.value;
      const currentTime = new Date();
      requestedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.requestedDate = requestedDate;
    }

    if (SalesOrder.requestedDate && SalesOrder.orderDate && new Date(SalesOrder.requestedDate).setHours(0, 0, 0, 0) < new Date(SalesOrder.orderDate).setHours(0, 0, 0, 0)) {
      this.loader = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Date Range',
        detail: 'The requested date cannot be earlier than the order date.'
      });
      return;
    }

    if (MoveToShipping) {
      SalesOrder.SalesOrderStatus = 'SHIPPING';
      SalesOrder.Status = 'Ready to Pick - 70%';
    }

    getISTDateWithCurrentTime(SalesOrder.CustomerPODate);

    this.loader = true;

    if (this.products.length > 0) {
      const updateRequests = this.products.map(p => {
        const payload = {
          ...p,
          NetAmount: _.round(p.NetAmount || 0, 2),
          LineTotal: _.round(p.LineTotal || 0, 2),
          DiscountAmount: _.round(p.DiscountAmount || 0, 2)
        };
        return this.salesService.updateSalesOrderLineItem(payload);
      });
      forkJoin(updateRequests).subscribe({
        error: (err) => console.error("Error syncing line items", err)
      });
    }

    if (this.products.length === 1 && value === 'TEMP.ORDER' && !this.isEdit) {
      this.salesService.createSalesOrder(SalesOrder as SalesOrder).subscribe(
        (data: any) => {
          this.loader = false;
          if (data.success === true) {
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    } else {
      if (this.isEdit) {
        SalesOrder.UpdatedBy = this.createOrderForm.controls.CreatedBy.value || '';
        SalesOrder.TermsCode = this.createOrderForm.get('TermsCode')?.value || '';
        SalesOrder.PaymentTermsId = this.createOrderForm.get('PaymentTermsId')?.value ?? undefined;
      }

      if (!SalesOrder.requestedDate) {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Warning',
          detail: 'RequestDate is Required'
        });
        return;
      }

      // console.log('POS=', this.createOrderForm.controls.POS.value);
      // console.log('SalesOrder=', SalesOrder);

      this.salesService.updateSalesOrder(SalesOrder as SalesOrder).subscribe(
        (data: any) => {
          this.loader = false;
          if (data) {
            // this.sendOrderEmail();
            if (value === 'ORDER' || value === 'SHIPPING') {
              if (sendEmail) {
                this.sendOrderEmail(data);
              }

              if (value === 'SHIPPING') {
                this.updateInventory('SHIPPING');
                this.loader = false;

                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: sendEmail ?
                    'Moved To Shipping & Email Sent.' :
                    'Moved To Shipping Successfully.'
                });
                setTimeout(() => {
                  this.router.navigate(['/home/dispatchSalesOrder']);
                }, 1000);
              } else {
                this.updateInventory();
                this.loader = false;
                let messageDetail = '';
                if (sendEmail) {
                  messageDetail = this.isEdit ? 'Order Updated & Email Sent.' : 'Order Created & Email Sent.';
                } else {
                  messageDetail = this.isEdit ? 'Order Updated Successfully.' : 'Order Created Successfully.';
                }

                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: messageDetail
                });


                setTimeout(() => {
                  this.router.navigate(['/home/listOrder']);
                }, 1000);
              }
            }
          } else {
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
          if (value === 'ORDER') {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Order.' });
          }
        }
      );
    }
  }

  isLineDiscountDisabled(): boolean {
    const discountAmount = Number(this.createOrderForm.get('DiscountAmount')?.value) || 0;
    return discountAmount > 0;
  }


  checkLineItemDiscounts() {
    const hasLineDiscount = this.products.some(p => Number(p.Discount) > 0);
    const discountControl = this.createOrderForm.get('DiscountAmount');
    if (hasLineDiscount) {
      discountControl?.setValue(0, { emitEvent: false });
      discountControl?.disable({ emitEvent: false });
    } else {
      discountControl?.enable({ emitEvent: false });
    }
    this.calculateOrderTotal();
  }

  // async calculateOrderTotal() {
  //   //this.checkIGST();
  //   await this.checkIGST();

  //   let totalWeight = 0;
  //   let taxableTotal = 0;
  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const getNum = (val: any) => _.toNumber(val) || 0;
  //   const parseCurrency = (val: any) =>
  //     parseFloat((val ?? 0).toString().replace(/[₹,]/g, '') || '0');

  //   const totalBeforeHeaderDiscount = this.products.reduce((sum, p) => {
  //     const quantity = getNum(p.OrderQuantity);
  //     const unitPrice = parseCurrency(p.UnitPrice);
  //     const lineDiscount = getNum(p.Discount) || 0;
  //     const amount = _.round(quantity * unitPrice, 2);
  //     p.Amount = amount;
  //     p.Discount = lineDiscount;
  //     p.DiscountAmount = lineDiscount;
  //     p.ExtensionPrice = amount;
  //     return sum + _.round(amount - lineDiscount, 2);
  //   }, 0);

  //   const hasLineDiscount = this.products.some(p => Number(p.Discount) > 0);

  //   const discountControl = this.createOrderForm.get('DiscountAmount');
  //   if (hasLineDiscount) {
  //     if (discountControl?.enabled) {
  //       discountControl.setValue(0, { emitEvent: false });
  //       discountControl.disable({ emitEvent: false });
  //     }
  //   } else {
  //     if (discountControl?.disabled) {
  //       discountControl.enable({ emitEvent: false });
  //     }
  //   }

  //   const orderDiscount = hasLineDiscount
  //     ? 0
  //     : getNum(discountControl?.value);

  //   for (const product of this.products) {
  //     const quantity = getNum(product.OrderQuantity);
  //     const amount = product.Amount || 0;
  //     const lineDiscount = product.Discount || 0;
  //     const afterLineDiscount = _.round(amount - lineDiscount, 2);

  //     const lineHeaderDiscountShare = (totalBeforeHeaderDiscount > 0 && orderDiscount > 0)
  //       ? _.round((afterLineDiscount / totalBeforeHeaderDiscount) * orderDiscount, 2)
  //       : 0;

  //     const netAmount = _.round(afterLineDiscount - lineHeaderDiscountShare, 2);
  //     product.NetAmount = netAmount;
  //     product.DiscountAmount = lineDiscount + lineHeaderDiscountShare;

  //     taxableTotal += netAmount;

  //     const isTaxable =
  //       (typeof product.IsTaxable === 'string' && product.IsTaxable === 'Y') ||
  //       (typeof product.IsTaxable === 'boolean' && product.IsTaxable);

  //     const gstRate = getNum(product.GSTRate) || 0;

  //     if (isTaxable) {
  //       let taxAmount = 0;
  //       if (gstRate > 0) {
  //         taxAmount = _.round((netAmount * gstRate) / 100, 2);

  //         if (this.isIGST) {
  //           igst += taxAmount;
  //         } else {
  //           cgst += _.round(taxAmount / 2, 2);
  //           sgst += _.round(taxAmount / 2, 2);
  //         }
  //       }

  //       product.SalesTax = taxAmount;
  //       product.CGST = this.isIGST ? 0 : _.round(taxAmount / 2, 2);
  //       product.SGST = this.isIGST ? 0 : _.round(taxAmount / 2, 2);
  //       product.IGST = this.isIGST ? taxAmount : 0;
  //     } else {
  //       product.SalesTax = 0;
  //       product.CGST = 0;
  //       product.SGST = 0;
  //       product.IGST = 0;
  //     }

  //     product.LineTotal = _.round(netAmount + product.SalesTax, 2);
  //     totalWeight += quantity;
  //   }

  //   const freightTotal = _.round(getNum(this.createOrderForm.get('FreightTotal')?.value) || 0, 2);
  //   const gstOnFreightRate = _.round(getNum(this.createOrderForm.get('RateOnFreight')?.value) || 0, 2);

  //   let freightGST = 0;
  //   if (freightTotal > 0 && gstOnFreightRate > 0) {
  //     freightGST = _.round((freightTotal * gstOnFreightRate) / 100, 2);
  //     if (this.isIGST) {
  //       igst += freightGST;
  //     } else {
  //       cgst += _.round(freightGST / 2, 2);
  //       sgst += _.round(freightGST / 2, 2);
  //     }
  //   }

  //   const maxDiscount = _.round(totalBeforeHeaderDiscount + freightTotal, 2);

  //   if (!hasLineDiscount && orderDiscount > maxDiscount && maxDiscount > 0) {
  //     if (discountControl?.dirty && !discountControl?.hasError('exceedTotal')) {
  //       this.messageService.clear();
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Invalid Discount',
  //         detail: `Discount cannot be greater than order total.`
  //       });
  //     }
  //     discountControl?.setErrors({ exceedTotal: true });
  //   } else {
  //     if (discountControl?.hasError('exceedTotal')) {
  //       discountControl.setErrors(null);
  //     }
  //   }

  //   const finalTaxableAmount = _.round(taxableTotal + freightTotal, 2);
  //   const orderTotal = _.round(finalTaxableAmount + cgst + sgst + igst, 2);

  //   this.weightTotal = _.round(totalWeight, 2);
  //   this.Taxable = _.round(taxableTotal, 2);
  //   this.NonTaxableTotal = 0;
  //   this.CGSTtotal = this.isIGST ? 0 : _.round(cgst, 2);
  //   this.SGSTtotal = this.isIGST ? 0 : _.round(sgst, 2);
  //   this.IGSTtotal = this.isIGST ? _.round(igst, 2) : 0;
  //   this.FinalTaxableAmt = finalTaxableAmount;
  //   this.orderTotal = orderTotal;

  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }

  //new code
  async calculateOrderTotal() {

    await this.checkIGST();

    const form = this.createOrderForm.value;

    const isLUT =
      form.isLUT === true &&
      (
        form.supplyType === 'EXPORT' ||
        form.supplyType === 'SEZ'
      );

    const isRCM = form.isRCM === true;

    let totalWeight = 0;
    let taxableTotal = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    const getNum = (val: any) => _.toNumber(val) || 0;

    const parseCurrency = (val: any) =>
      parseFloat(
        (val ?? 0)
          .toString()
          .replace(/[₹,]/g, '') || '0'
      );

    const totalBeforeHeaderDiscount = this.products.reduce((sum, p) => {

      const quantity = getNum(p.OrderQuantity);
      const unitPrice = parseCurrency(p.UnitPrice);
      const lineDiscountPercent = getNum(p.Discount);

      const amount = _.round(quantity * unitPrice, 2);

      p.Amount = amount;
      p.ExtensionPrice = amount;

      // Calculate discount amount as percentage of amount using utility function
      const lineDiscountAmount = discountAmountFromPercent(amount, lineDiscountPercent);
      p.DiscountAmount = lineDiscountAmount;

      return sum + _.round(amount - lineDiscountAmount, 2);

    }, 0);

    const hasLineDiscount =
      this.products.some(p => Number(p.Discount) > 0);

    const discountControl =
      this.createOrderForm.get('DiscountAmount');

    if (hasLineDiscount) {

      if (discountControl?.enabled) {
        discountControl.setValue(0, { emitEvent: false });
        discountControl.disable({ emitEvent: false });
      }

    } else {

      if (discountControl?.disabled) {
        discountControl.enable({ emitEvent: false });
      }
    }

    const orderDiscount =
      hasLineDiscount
        ? 0
        : getNum(discountControl?.value);

    for (const product of this.products) {

      const quantity = getNum(product.OrderQuantity);

      const amount = getNum(product.Amount);

      const lineDiscountPercent = getNum(product.Discount);

      // Calculate discount amount as percentage of amount using utility function
      const lineDiscountAmount = discountAmountFromPercent(amount, lineDiscountPercent);

      const afterLineDiscount =
        _.round(amount - lineDiscountAmount, 2);

      // Header discount only affects summary, not line calculations
      const netAmount = afterLineDiscount;

      product.NetAmount = netAmount;

      product.DiscountAmount = lineDiscountAmount;

      taxableTotal += netAmount;

      const isTaxable =
        (typeof product.IsTaxable === 'string' &&
          product.IsTaxable === 'Y')
        ||
        (typeof product.IsTaxable === 'boolean' &&
          product.IsTaxable);

      const gstRate =
        getNum(product.GSTRate);

      let taxAmount = 0;

      if (isTaxable && gstRate > 0) {

        // No GST for LUT or RCM
        if (!isLUT && !isRCM) {

          taxAmount =
            _.round(
              (netAmount * gstRate) / 100,
              2
            );

          if (this.isIGST) {

            product.IGST = taxAmount;
            product.CGST = 0;
            product.SGST = 0;

            igst += taxAmount;

          } else {

            product.CGST =
              _.round(taxAmount / 2, 2);

            product.SGST =
              _.round(taxAmount / 2, 2);

            product.IGST = 0;

            cgst += product.CGST;
            sgst += product.SGST;
          }

        } else {

          product.CGST = 0;
          product.SGST = 0;
          product.IGST = 0;
        }

      } else {

        product.CGST = 0;
        product.SGST = 0;
        product.IGST = 0;
      }

      product.SalesTax =
        product.CGST +
        product.SGST +
        product.IGST;

      product.LineTotal =
        _.round(
          netAmount + product.SalesTax,
          2
        );

      totalWeight += quantity;
    }

    // Freight GST

    const freightTotal =
      _.round(
        getNum(
          this.createOrderForm.get('FreightTotal')?.value
        ),
        2
      );

    const freightRate =
      _.round(
        getNum(
          this.createOrderForm.get('RateOnFreight')?.value
        ),
        2
      );

    let freightGST = 0;

    if (
      freightTotal > 0 &&
      freightRate > 0 &&
      !isLUT &&
      !isRCM
    ) {

      freightGST =
        _.round(
          (freightTotal * freightRate) / 100,
          2
        );

      if (this.isIGST) {

        igst += freightGST;

      } else {

        cgst += _.round(freightGST / 2, 2);
        sgst += _.round(freightGST / 2, 2);
      }
    }

    const maxDiscount =
      _.round(
        totalBeforeHeaderDiscount + freightTotal,
        2
      );

    if (
      !hasLineDiscount &&
      orderDiscount > maxDiscount &&
      maxDiscount > 0
    ) {

      if (
        discountControl?.dirty &&
        !discountControl?.hasError('exceedTotal')
      ) {

        this.messageService.clear();

        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Discount',
          detail:
            'Discount cannot be greater than order total.'
        });
      }

      discountControl?.setErrors({
        exceedTotal: true
      });

    } else {

      if (discountControl?.hasError('exceedTotal')) {
        discountControl.setErrors(null);
      }
    }

    const finalTaxableAmount =
      _.round(
        taxableTotal + freightTotal - orderDiscount,
        2
      );

    const orderTotal =
      _.round(
        finalTaxableAmount +
        cgst +
        sgst +
        igst,
        2
      );

    this.weightTotal =
      _.round(totalWeight, 2);

    this.Taxable =
      _.round(taxableTotal, 2);

    this.NonTaxableTotal = 0;

    this.CGSTtotal =
      _.round(cgst, 2);

    this.SGSTtotal =
      _.round(sgst, 2);

    this.IGSTtotal =
      _.round(igst, 2);

    this.FinalTaxableAmt =
      finalTaxableAmount;

    this.createOrderForm.patchValue({
      FinalTaxableAmt: finalTaxableAmount
    }, { emitEvent: false });

    this.orderTotal =
      orderTotal;

    this.products =
      _.cloneDeep(this.products);

    // console.log('Supply Type:', form.supplyType);
    // console.log('RCM:', isRCM);
    // console.log('LUT:', isLUT);
    // console.log('IGST:', this.isIGST);

    return true;
  }


  calculateGST(price: number, quantity: number, gstrate: number, taxable: boolean): number {
    if (taxable === true) {
      const gst = (price * quantity) * gstrate / 100;
      return gst;
    }
    else {
      return 0;
    }
  }

  async onProductEdit(event: any) {
    let editData = event;

    const getNum = (val: any) => _.toNumber(val) || 0;
    const parseCurrency = (val: any) =>
      parseFloat((val ?? 0).toString().replace(/[₹,]/g, '') || '0');



    const productId = editData.ProductId;
    let costCalculationType: string;

    try {
      const productData = await this.getProductById(productId);
      costCalculationType = productData.costCalculation || 'Qty';
    } catch (error) {
      console.error('Failed to fetch product data:', error);
      this.loader = false;
      return;
    }

    if (costCalculationType === 'Qty' && editData.OrderQuantity <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Value',
        detail: 'OrderQuantity must be greater than 0.'
      });
      return;
    }

    if (costCalculationType === 'Wgt' && editData.Weight <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Value',
        detail: 'Weight must be greater than 0.'
      });
      return;
    }

    let extensionPrice: number;
    if (costCalculationType === 'Qty') {
      extensionPrice = editData.UnitPrice * editData.OrderQuantity;
    } else if (costCalculationType === 'Wgt') {
      extensionPrice = editData.Weight * editData.UnitPrice;
    } else {
      console.warn('Unknown costCalculation type:', costCalculationType);
      extensionPrice = 0;
    }

    const lineDiscountPercent = getNum(editData.Discount) || 0;
    const lineAmount = extensionPrice;

    // Validate that discount percentage is between 0 and 100
    if (lineDiscountPercent > 100) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Discount',
        detail: `Line discount percentage cannot be greater than 100%.`
      });
      return;
    }

    editData.ExtensionPrice = extensionPrice;
    editData.Discount = lineDiscountPercent;
    
    // Calculate discount amount as percentage of amount
    const lineDiscountAmount = discountAmountFromPercent(lineAmount, lineDiscountPercent);
    editData.DiscountAmount = lineDiscountAmount;

    const gstRate = getNum(editData.GSTRate) || 0;

    let salesTax: number;
    if (costCalculationType === 'Wgt') {
      salesTax = _.round((editData.Weight * editData.UnitPrice * gstRate) / 100, 2);
    } else if (costCalculationType === 'Qty') {
      salesTax = _.round((editData.UnitPrice * editData.OrderQuantity * gstRate) / 100, 2);
    } else {
      salesTax = 0;
    }

    editData.SalesTax = salesTax;
    editData.CGST = (!this.isIGST) ? _.round(salesTax / 2, 2) : 0;
    editData.SGST = (!this.isIGST) ? _.round(salesTax / 2, 2) : 0;
    editData.IGST = (this.isIGST) ? salesTax : 0;

    editData.UnitPrice = _.toNumber(editData.UnitPrice).toFixed(2);
    editData.NetAmount = _.round(editData.ExtensionPrice - editData.DiscountAmount, 2);
    editData.LineTotal = _.round(editData.NetAmount + editData.SalesTax, 2);

    if (!this.isEdit) {
      const index = this.products.findIndex(
        product => product.SalesOrderLineItemId === editData.SalesOrderLineItemId
      );

      if (index !== -1) {
        this.updateSalesOrderLineItems(editData, index);
      } else {
        console.error('Product not found', editData);
        this.messageService.add({
          severity: 'error',
          summary: 'Warning',
          detail: 'Error while updating product'
        });
      }
    } else {
      const index = this.products.findIndex(
        product => product.LineItemNumber === editData.LineItemNumber
      );

      if (index !== -1) {
        this.products[index] = {
          ...editData,
          ExtensionPrice: editData.ExtensionPrice,
          CGST: editData.CGST,
          SGST: editData.SGST,
          IGST: editData.IGST,
          SalesTax: editData.SalesTax,
          UnitPrice: editData.UnitPrice,
          Discount: editData.Discount,
          DiscountAmount: editData.DiscountAmount,
          NetAmount: editData.NetAmount,
          LineTotal: editData.LineTotal
        };
        this.checkLineItemDiscounts();
      } else {
        console.error('Product not found', editData);
      }
    }
  }

  updateSalesOrderLineItems(data: Product, index: number) {
    // this.loader = true;
    this.salesService.updateSalesOrderLineItem(data).subscribe(
      async (response: any) => {
        // console.log(response);
        // Update this.products only if the update is successfull
        if (index !== -1) {
          this.products[index] = {
            ...data,
            ExtensionPrice: data.ExtensionPrice,
            CGST: data.CGST,
            SGST: data.SGST,
            IGST: data.IGST,
            SalesTax: data.SalesTax,
            UnitPrice: data.UnitPrice,
            DiscountAmount: data.DiscountAmount,
            NetAmount: data.NetAmount,
            LineTotal: data.LineTotal
          };
          const isValid = this.calculateOrderTotal();
          if (await isValid) {
            this.createSalesOrder('TEMP.ORDER');
          }
        }
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
        this.loader = false;
      }
    );
  }

  deleteProduct(reset: boolean = false) {

    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      message: 'Do you want to delete?',
      accept: () => {

        var selectedProductIds: any
        if (!this.isEdit) {

          if (reset) {
            selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);
          } else {
            selectedProductIds = this.selectedProduct.map(product => product.SalesOrderLineItemId);
          }

          this.loader = true;
          this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
            next: async (data: any) => {
              if (data) {
                this.loader = false;
                this.products = this.products.filter(product => !selectedProductIds.includes(product.SalesOrderLineItemId));
                this.selectedProduct = [];
                // this.calculateOrderTotal();
                const isValid = this.calculateOrderTotal();
                if (await isValid) {
                  this.createSalesOrder('TEMP.ORDER');
                }
                if (reset) {
                  setTimeout(() => {
                    const OrderNo = this.createOrderForm.controls.OrderNo.value;
                    this.createOrderForm.reset();
                    this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
                    this.createOrderForm.controls.OrderNo.setValue(OrderNo);
                  }, 2000);
                }
              }
            },
            error: error => {
              console.log(error);
              this.loader = false;
              this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while deleting product' });
            }
          });
        } else {
          this.deleteProductIds.push(
            ...this.selectedProduct
              .map(product => product.SalesOrderLineItemId)
              .filter(id => {
                return id && id.toString().trim() !== '';
              })
          );

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();
        }

      },
      reject: () => {
      }
    });

  }

  reOpen() {
    this.route.queryParams.subscribe(params => {
      try {
        const salesOrderId = JSON.parse(params['Data']);
        this.loader = true;
        this.salesService.getSalesOrderById(salesOrderId).subscribe({
          next: (data: any) => {
            if (data) {
              this.Data = data;
              this.isEdit = true;
              this.selectedOrder = data;
              const BillToCustomerAddress = data.billToCustomer?.address
                ? `${data.billToCustomer.address.state}, ${data.billToCustomer.address.country}, ${data.billToCustomer.address.zip}`
                : '';

              const ShipToCustomerAddress = data.shipToCustomer?.address
                ? `${data.shipToCustomer.address.state}, ${data.shipToCustomer.address.country}, ${data.shipToCustomer.address.zip}`
                : '';

              // console.log('API Response POS:', data.pos);
              // console.log('Full Data:', data);

              this.createOrderForm.patchValue({
                OrderNo: data.salesOrderNumber,
                BillToCustomerCode: data.billToCustomerCode,
                BillToCustomerId: data.billToCustomerId,
                BillToCustomer: data.billToCustomer?.customerName,
                ShipToCustomerCode: data.shipToCustomerCode,
                ShipToCustomerId: data.shipToCustomerId,
                ShipToCustomer: data.shipToCustomer?.customerName,
                SalespersonCode: data.salespersonCode,
                SalespersonId: data.salespersonId,
                salesperson: data.salesperson?.salespersonName,
                ShipmentDate: data.shipmentDate ? new Date(data.shipmentDate) : '',
                MotorVehicalNo: data.motorVehicleNo,
                deliveryNote: data.deliveryNote,
                warehouse: data.warehouse?.warehouseName,
                WareHouseId: data.warehouseId,
                TermsCode: data.termsCode,
                PaymentTermsId: data.paymentTermsId,
                DispatchDocNo: data.dispatchDocNo,
                BillOfLading: data.billOfLading,
                purchaseOrderNumber: data.purchaseOrderNumber,
                LRRRNo: data.lrrrNo,
                DispatchThrough: data.dispatchThrough,
                BillToCustomerAddress: BillToCustomerAddress,
                ShipToCustomerAddress: ShipToCustomerAddress,
                BillToCustomerState: data.billToCustomer?.address?.state,
                BillToCustomerStateCode: data.billToCustomer?.address?.stateCode,
                ShipToCustomerStateCode:
                  data.shipToCustomer?.address?.stateCode,

                warehouseStateCode:
                  data.warehouse?.address?.stateCode,

                warehouseState: data.warehouse?.address?.state,
                orderDate: data.orderDate ? new Date(data.orderDate) : new Date(),
                requestedDate: data.requestedDate ? new Date(data.requestedDate) : null,
                ReferenceNumber: data.referenceNumber,
                Destination: data.destination,
                TermsOfDelivery: data.termsOfDelivery,
                CustomerPODate: data.customerPODate ? new Date(data.customerPODate) : null,
                Status: data.status ?? 'Draft - 0%',
                GSTOnFreight: data.gstOnFreight,
                FreightTotal: data.freightTotal,
                RateOnFreight: data.rateOnFreight,
                DiscountAmount: data.discountAmount,
                FinalTaxableAmt: data.FinalTaxableAmt,
                supplyType: data.supplyType,
                isLUT: data.isLUT ?? false,
                expTyp: data.exportType ?? '',
                isRCM: data.isRCM ?? false,
                POS: data.pos ?? '',
                FinancialYearId: data.financialYearId ?? data.FinancialYearId,
                projectBoMId: data.projectBoMId ?? null,
                projectName: data.projectName || data.projectBoM?.projectBoMName || '',
                projectNo: data.projectNo || data.projectBoM?.projectBoMCode || '',
              });

              const orderDate = this.createOrderForm.get('orderDate')?.value;
              if (orderDate) {
                this.onTransactionDateChange(orderDate, "Order");
              }

              const requestedDate = this.createOrderForm.get('requestedDate')?.value;
              if (requestedDate) {
                this.onTransactionDateChange(requestedDate, "Requested");
              }
              this.subscribeFinancialYearChanges();

              this.customerEmail = data.billToCustomer?.email
                || data.customer?.email
                || data.customer?.emailID1
                || null;
              this.selectedCustomerEmail = this.customerEmail;
              this.selectedCustomerName = data.billToCustomer?.customerName
                || data.customer?.customerName
                || this.selectedCustomerName;

              this.updateRCMState(data.supplyType);

              setTimeout(() => {
                this.setPlaceOfSupply();
                this.setExportType();
                this.isIGST =
                  this.isIGSTApplicable();
                this.calculateOrderTotal();
              });

              this.deliveryDate = data.requestedDate;
              this.orderTotal = data.orderTotal;
              this.SalesTaxTotal = data.salesTaxTotal;
              this.CGSTtotal = data.cgstTotal;
              this.SGSTtotal = data.sgstTotal;
              this.IGSTtotal = data.igstTotal;
              this.Status = data.status;
              this.ShipmentDate = data.shipmentDate ? new Date(data.shipmentDate) : '',

                this.getSalesOrderLineItems(data.salesOrderNumber);
              if (data.billToCustomerId) {
                this.loadOutstandingAmount(data.billToCustomerId);
              }
              // this.getShipto(data.shipToCustomerId);
              this.loader = false;

              // if (data.status === 'Open') {
              //   this.isOpenStatus = data.status === 'Open';
              // }

              //console.log('Form POS:', this.createOrderForm.get('POS')?.value);
              // console.log(
              //   'BillToCustomerStateCode:',
              //   this.createOrderForm.get('BillToCustomerStateCode')?.value
              // );
            }
          },
          error: error => {
            console.error(error);
            this.loader = false;
          }
        });
      } catch (error) {
        console.error('Error parsing query param:', error);
      }
    });
  }

  getShipto(data: number) {
    this.loader = true;
    this.customerService.getCustomerById(data).subscribe({
      next: (data: any) => {
        const ShipTo = data;
        this.createOrderForm.controls.ShipToCustomer.setValue(ShipTo.customerName);
        const address = `${ShipTo.address.city, ShipTo.address.state}, ${ShipTo.address.country}, ${ShipTo.address.zip}`;
        this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
        this.loader = false;

      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })
  }

  getSalesOrderLineItems(salesOrderNumber: number) {
    this.loader = true;
    this.salesService.getSalesOrderLineItem(salesOrderNumber).subscribe(
      (data: any) => {
        this.products = this.loadProducts(data);
        this.quoation = (this.products[0].QuotedQuantity) ? true : false;
        this.allProductData = _.cloneDeep(this.products);
        this.calculateOrderTotal();
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  loadProducts(data: any): Product[] {
    return data.map((item: any) => {
      return this.loadProduct(item);
    });
  }

  loadProduct(data: any) {
    const product: Product = <Product>{
      SalesOrderLineItemId: data.salesOrderLineItemId,
      SalesOrderNumber: data.salesOrderNumber,
      ProductId: data.productId,
      OrderQuantity: data.orderQuantity,
      QuotedQuantity: data.quotedQuantity,
      Uom: data.uom,
      LineItemNumber: data.lineItemNumber,
      IsTaxable: data.isTaxable,
      StandardCost: data.standardCost,
      UnitPrice: data.unitPrice,
      ExtensionPrice: data.extensionPrice,
      Discount: data.discount || 0,
      DiscountAmount: data.discountAmount || 0,
      LineTotal: data.lineTotal || 0,
      NetAmount: data.netAmount || 0,
      GSTRate: data.gstRate,
      HSNCode: data.hsnCode,
      CGST: data.cgst,
      SGST: data.sgst,
      IGST: data.igst,
      SalesTax: data.salesTax,
      Weight: data.weight,
      Comment: data.comment,
      deliveryDate: data.deliveryDate ? new Date(data.deliveryDate) : null,
      createdDate: data.createdDate,
      WareHouseId: data.wareHouseId,
      ProductCode: data.productCode,
      ProductDescription: data.productDescription,
      ProductSpecification: data.productSpecification,
      CreatedBy: data.createdBy,
      IsActive: true,
      DepartmentId: 0,
      LocationId: 0,
      SerialId: 0,
      VendnorId: 0,
    }
    return product;
  }

  movetoShipping() {
    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    this.update(true);
  }


  async update(MoveToShipping: boolean = false, sendEmail: boolean = false) {
    this.submitted = true;

    // 1️⃣ Validate form
    if (!this.validateForm()) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }

    // 2️⃣ Validate products
    if (this.products.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Please enter product.'
      });
      return;
    }

    for (const product of this.products) {
      if (product.UnitPrice < 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Value',
          detail: 'Price cannot be negative.'
        });
        return;
      }

      const validProductId = product.ProductId || this.productId;
      const productData = await this.getProductById(validProductId);
      const costCalculationType = productData?.costCalculation || 'Qty';

      if (costCalculationType.toLowerCase() === 'qty' && product.OrderQuantity <= 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Value',
          detail: 'OrderQuantity must be greater than 0.'
        });
        return;
      }

      if (costCalculationType.toLowerCase() === 'wgt' && product.Weight <= 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Value',
          detail: 'Weight must be greater than 0.'
        });
        return;
      }

      if (!product.ProductDescription) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Value',
          detail: 'Product Name is Required'
        });
        return;
      }
    }

    this.loader = true;

    try {
      // 3️⃣ PREPARE SHIPPING QTY (CRITICAL FIX)
      if (MoveToShipping) {
        this.products = this.products.map(p => ({
          ...p,
          ShipedQuantity: Number(p.OrderQuantity) || 0,
          ShipedWeight: Number(p.Weight) || 0
        }));
      }

      // 4️⃣ DELETE REMOVED LINE ITEMS
      if (this.deleteProductIds.length > 0) {
        await this.salesService
          .deleteSalesOrderLineItem(this.deleteProductIds)
          .toPromise();

        this.deleteProductIds = [];
      }

      // 5️⃣ CREATE / UPDATE LINE ITEMS
      const requests = this.products.map(product => {
        if (product.deliveryDate) {
          const correctedDate = new Date(product.deliveryDate);
          const now = new Date();
          correctedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
          product.deliveryDate = correctedDate;
        }

        return product.SalesOrderLineItemId
          ? this.salesService.updateSalesOrderLineItem(product).toPromise()
          : this.salesService.createSalesOrderLineItem(product).toPromise();
      });

      await Promise.all(requests);

      // 6️⃣ UPDATE INVENTORY
      await this.updateInventory(MoveToShipping ? 'SHIPPING' : 'DirectOrder');

      // 7️⃣ CREATE ORDER / SHIPPING
      if (MoveToShipping) {
        await this.createSalesOrder('SHIPPING', true, sendEmail);
      } else {
        await this.createSalesOrder('ORDER', false, sendEmail);
      }

    } catch (error) {
      console.error(error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to process order.'
      });
    } finally {
      this.loader = false;
    }
  }


  updateInventory(status: string = "DirectOrder") {
    this.loader = true;

    const data = this.createOrderForm.value;

    for (let product of this.allProductData) {

      const productId = product.ProductId || this.productId;
      //Updating the product inventory

      const Inventory: UpdateInventory = <UpdateInventory>{
        productId: productId,
        warehouseId: _.toNumber(data.WareHouseId),
        productCode: product.ProductCode,
        status: status,
        transactionNo: _.toString(data.OrderNo),
        transactionType: "Order",
        quantity: product.OrderQuantity,
        createdBy: localStorage.getItem('username'),
        transactionDate: new Date(),
        createdDate: new Date(),
      }

      // console.log(Inventory);
      this.inventoryService.updateInventoryNew(Inventory).subscribe({
        next: (data: any) => {
          // console.log(data);
          this.loader = false;
        },
        error: error => {
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while Inventory Update.' });
          this.loader = false;
          return;
        }
      });

    }
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  onKeydown(event: KeyboardEvent, product: any) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      this.onProductEdit(product);
      if (event.key === 'Tab') {
        this.moveFocusToNextField(event, product);
      }
    }
  }

  moveFocusToNextField(event: KeyboardEvent, product: any) {
    const inputs = document.querySelectorAll('input');
    const currentIndex = Array.from(inputs).indexOf(event.target as HTMLInputElement);
    const nextInput = inputs[currentIndex + 1] as HTMLInputElement;

    if (nextInput) {
      nextInput.focus();
    }
  }

  viewProduct(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;

    const ref = this.dialogService.open(viewproductLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: productDataJson,
        productId: this.productId
      }
    });

    let messageShown = false;

    ref.onClose.subscribe(updatedProduct => {
      if (updatedProduct && !messageShown) {
        this.updateProductInGrid(productData, updatedProduct);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Product updated successfully.`
        });
        messageShown = true;
      }
    });
  }

  updateProductInGrid(originalProduct: any, updatedProduct: any) {
    originalProduct.ProductCode = updatedProduct.ProductCode;
    originalProduct.ProductDescription = updatedProduct.ProductName;
    originalProduct.Uom = updatedProduct.unitsofMeasure || updatedProduct.UnitsOfMeasure;
    originalProduct.HSNCode = updatedProduct.HSNCode;
    originalProduct.GSTRate = +updatedProduct.gstRate || 0;
    originalProduct.UnitPrice = updatedProduct.SalesPrice;
    originalProduct.ExtensionPrice = updatedProduct.
      SalesPrice * originalProduct.OrderQuantity;
    originalProduct.ProductSpecification = updatedProduct.ProductSpecification;

    const quantity = +originalProduct.OrderQuantity || 0;
    const unitPrice = +originalProduct.UnitPrice || 0;
    const gstRate = originalProduct.GSTRate;

    const baseAmount = +(unitPrice * quantity).toFixed(2);

    const salesTax = +((baseAmount * gstRate) / 100).toFixed(2);

    originalProduct.TaxableAmount = baseAmount;
    originalProduct.SalesTax = salesTax;
    originalProduct.TotalWithTax = +(baseAmount + salesTax).toFixed(2);
    originalProduct.ExtendedCost = baseAmount;

    // Reset IGST/CGST/SGST based on tax mode
    if (this.isIGST) {
      originalProduct.IGST = salesTax;
      originalProduct.CGST = 0;
      originalProduct.SGST = 0;
    } else {
      const half = +(salesTax / 2).toFixed(2);
      originalProduct.CGST = half;
      originalProduct.SGST = half;
      originalProduct.IGST = 0;
    }

    this.products = [...this.products];
    this.calculateOrderTotal();
  }

  private normalizeProductIdInPlace(product: any): any {
    if (product && product.ProductId) {
      product.productId = product.ProductId;
      delete product.ProductId;
    }
    return product;
  }

  async toggleEdit(product: Product, field: 'Weight' | 'OrderQuantity') {
    try {
      const productData = await this.getProductById(product.ProductId);
      const costCalculationType = productData.costCalculation || 'Qty';
      this.isEditingQuantity = false;
      this.isEditingWeight = false;
      if (costCalculationType === 'Qty' && field === 'OrderQuantity') {
        this.isEditingQuantity = true;
      } else if (costCalculationType === 'Wgt' && field === 'Weight') {
        this.isEditingWeight = true;
      }
      // else if (costCalculationType === 'Wgt' && field === 'OrderQuantity') {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Cannot edit Quantity because the product type is Weight (Wgt).' });
      //   return;
      // } else if (costCalculationType === 'Qty' && field === 'Weight') {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Cannot edit Weight because the product type is Quantity (Qty).' });
      //   return;
      // }
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }

  getFormControlName(): string {
    return this.productCostCalculationType === 'Qty' ? 'productQty' : 'productWgt';
  }

  getPlaceholder(): string {
    return this.productCostCalculationType === 'Qty' ? 'Qty' : 'Wgt';

  }

  createQuickProduct() {
    this.submitted = true;

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      return;
    }

    this.ref = this.dialogService.open(CloseQuickProductLookupComponent, {
      header: 'Create Quick Product',
      width: '70%',

    });
    this.ref.onClose.subscribe((data: Product) => {
      if (data) {
        const product = { value: data };
        this.setProduct(product);
      }
    });
  }

  showSpecification(productItem: any) {
    if (!productItem.ProductId && !productItem.productId) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Incomplete Product Data.' });
      return;
    }
    this.ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Order Line Specification',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        productItem.ProductSpecification = data.ProductSpecification;
        this.onProductEdit(productItem);
      }
    });
  }

  showProductUom(productItem: Product) {
    this.ref = this.dialogService.open(UOMLookupComponent, {
      header: 'Unit of Measure',
      width: '60%',

    });
    this.ref.onClose.subscribe((selectedUOM: UnitsOfMeasure) => {
      if (selectedUOM) {
        productItem.Uom = selectedUOM.unitsofMeasure;
        this.onProductEdit(productItem);
      }
    });
  }

  openLinkedFiles() {
    if (this.ref) {
      this.ref.close();
    }
    const orderNo = this.createOrderForm.controls.OrderNo.value;
    this.ref = this.dialogService.open(ListLinkedFilesLookupComponent, {
      header: `Linked File For Order ${orderNo}`,
      width: '60%',
      data: { orderNo: orderNo }
    });
  }

  showComment(productItem: Product) {
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'Order Line Remark',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onProductEdit(productItem);
      }
    });
  }

  createQuickCustomer(status: boolean = true) {
    this.ref = this.dialogService.open(CloseQuickCustomerLookupComponent, {
      header: 'Create Quick Customer',
      width: '70%',

    });
    this.ref.onClose.subscribe((customerId: number) => {
      if (customerId) {
        this.getCustomerData(customerId, status);
      }
    });
  }

  getCustomerData(id: number, status: boolean) {
    this.customerService.getCustomerById(id).subscribe(
      (data: any) => {
        const customerData = {
          value: data
        }
        if (status) {
          this.setBillTo(customerData);
        } else {
          if (data.isShipToCustomer === true) {
            this.setShipTo(customerData);
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'It cannot be shipped to the customer.' });
          }
        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching customer data.' });
      }
    );
  }


  getInventoryStatus(productCode: string) {
    const warehouseId: number = _.toNumber(this.createOrderForm.value.WareHouseId) || 0;
    if (!warehouseId) {
      return;
    }
    this.inventoryService.getInventoryStatusByProductWarehouse(productCode, warehouseId).subscribe({
      next: (data: any) => {
        if (data)
          this.QAvail = data.quantityAvailable;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  sendOrderEmail(order: any) {

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'Order';
    this.loader = true;

    const templateCode =
      order && this.isEdit === true
        ? 'sales-order-status-update-template'
        : 'order-email-template';

    this.getUserDepartmentName().subscribe(departmentName => {

      this.reportService.getReportName(formCode).pipe(

        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }
          this.ReportPath = report.path;
          return this.salesService.getEmailTemplate(tenant, templateCode);
        }),

        map((templateResponse: any) => {
          const template =
            templateResponse?.body ??
            templateResponse?.Body ??
            templateResponse?.templateBody ??
            templateResponse?.TemplateBody ??
            templateResponse?.emailBody ??
            templateResponse?.EmailBody;

          if (!template) {
            throw new Error('TEMPLATE_MISSING');
          }

          const formatCurrency = (value: any) => {
            const numericValue = typeof value === 'number' ? value : parseFloat(value);
            return `₹${(Number.isFinite(numericValue) ? numericValue : 0)
              .toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
          };

          const rawOrderDate =
            this.createOrderForm.controls.orderDate.value ||
            order?.SalesOrderDate ||
            order?.orderDate ||
            null;

          const safeDate = formatDateDDMMYY(rawOrderDate);
          const CustomerPODate = formatDateDDMMYY(this.createOrderForm.controls.CustomerPODate.value);
          const templateData = {
            customerName: this.createOrderForm.controls.BillToCustomer.value
              || this.createOrderForm.controls.BillToCustomerCode.value
              || order?.CustomerName
              || '',
            orderNumber: this.createOrderForm.controls.OrderNo.value
              || order?.purchaseOrderNumber
              || '',
            CustomerPONumber: this.createOrderForm.controls.purchaseOrderNumber.value
              || order?.purchaseOrderNumber
              || '',
            CustomerPODate: CustomerPODate,
            orderDate: safeDate,
            shipToName: this.createOrderForm.controls.ShipToCustomer.value
              || this.createOrderForm.controls.ShipToCustomerCode.value
              || order?.ShipToCustomerCode
              || '',
            salespersonName: this.createOrderForm.controls.salesperson.value
              || this.createOrderForm.controls.SalespersonCode.value
              || '',
            salespersonCode: this.createOrderForm.controls.SalespersonCode.value || '',
            warehouseName: this.createOrderForm.controls.warehouse.value
              || this.createOrderForm.controls.WareHouseId.value
              || '',
            orderTotal: formatCurrency(this.orderTotal),
            cgstTotal: formatCurrency(this.CGSTtotal),
            sgstTotal: formatCurrency(this.SGSTtotal),
            igstTotal: formatCurrency(this.IGSTtotal),
            salesTaxTotal: formatCurrency(this.SalesTaxTotal),
            currentYear: new Date().getFullYear(),
            companyName: this.companyInfo?.companyName || '',
            companyEmail: this.companyInfo?.companyEmail || '',
            companyPhone: this.companyInfo?.companyPhone || '',
            companyWebsite: this.companyInfo?.companyWebsite || '',
            orderStatus: this.createOrderForm.controls.Status.value || this.Status || '',
            expectedDispatchDate: formatDateDDMMYY(this.createOrderForm.controls.ShipmentDate.value || this.ShipmentDate),
          };

          return this.emailTemplateService.replacePlaceholders(template, templateData);
        }),

        switchMap((emailBody: string) => {

          if (!this.customerEmail) {
            throw new Error('EMAIL_MISSING');
          }

          const emailData = {
            EmailToId: this.customerEmail,
            EmailToName: this.resolveCustomerName(order),
            EmailSubject: `Order ${this.createOrderForm.controls.OrderNo.value || ''}`,
            EmailBody: emailBody,
            OrderNumber: this.createOrderForm.controls.OrderNo.value,
            OrderType: 'SalesOrder',
            TenantId: tenant,
            ReportPath: this.ReportPath,
            DepartmentName: departmentName
          };

          return this.salesService.SendMail(emailData);
        })

      ).subscribe({
        next: () => {
          this.loader = false;
          this.createRecentInteractions(departmentName);
        },
        error: (err) => {
          this.loader = false;

          let message = 'Email failed to send.';

          if (err.message === 'REPORT_MISSING') {
            message = 'Report not available. Email sending aborted.';
          } else if (err.message === 'TEMPLATE_MISSING') {
            message = 'Email template not found.';
          } else if (err.message === 'EMAIL_MISSING') {
            message = 'Customer email is missing.';
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: message
          });
        }
      });
    });
  }


  private resolveCustomerName(order: any): string {
    return (
      this.createOrderForm.controls.BillToCustomer.value ||
      order?.customer?.customerName ||
      order?.CustomerName ||
      this.selectedCustomerName ||
      this.createOrderForm.controls.BillToCustomerCode.value ||
      'Customer'
    );
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  createRecentInteractions(departmentName: string = '') {
    const formData = this.createOrderForm.value;
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: "Send Mail",
          from: fromEmail,
          to: this.customerEmail || 'default@example.com',
          subject: `Order ${this.createOrderForm.controls.OrderNo.value || ''} ${this.createOrderForm.controls.Status.value || this.Status || ''}`,
          customerNumber: formData.BillToCustomerCode ?? '',
          description: "Order successfully placed",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => console.log('Recent interaction created:', res),
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  getSystemConfigData(): void {
    this.loader = true;

    const configs = [
      { key: 'inventory.qavail_warning' },
      { key: 'auto_order_email' }
    ];

    const requests = configs.map(config =>
      this.inventoryService.getSystemConfigByAppKey(config.key)
    );

    forkJoin(requests).subscribe({
      next: (responses: any[]) => {
        responses.forEach(response => {
          switch (response?.appKeycode) {

            case 'inventory.qavail_warning':
              if (response?.data === 'Y') {
                this.isQAvailWarning = true;
              }
              break;

            case 'auto_order_email':
              this.canSendEmail = true;
              this.autoSendEmail = response?.data === 'Y';
              break;

          }
        });

        this.loader = false;
      },
      error: error => {
        console.error('Error fetching System Config Data:', error);
        this.loader = false;
      }
    });
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  supplyTypes = [
    { code: 'B2B', description: 'Business to Business' },
    { code: 'SEZWP', description: 'SEZ with payment' },
    { code: 'SEZWOP', description: 'SEZ without payment' },
    { code: 'EXPWP', description: 'Export with Payment' },
    { code: 'EXPWOP', description: 'Export without Payment' },
    { code: 'DEXP', description: 'Deemed Export' }
  ];


  getSupplyType(customer: any): string {


    //const code = customer.gstTreatmentCode || customer.gstTreatment; // fallback
    const code = customer.GSTTreatmentCode || customer.gstTreatmentCode || customer.gstTreatment;

    // const isSEZ = customer.isSEZ == 1 || customer.isSEZ === true;
    // const isOverseas = customer.isOverseas == 1 || customer.isOverseas === true;

    const isSEZ = code === 'SEZ';
    const isOverseas = code === 'OVR';

    // console.log('Customer:', customer);
    // console.log('Code:', code);
    // console.log('isSEZ:', isSEZ);
    // console.log('isOverseas:', isOverseas);

    // ✅ EXPORT (highest priority)
    if (isOverseas || customer.address?.country !== 'India') {
      return 'EXPORT';
    }

    // ✅ SEZ
    if (isSEZ || code === 'SEZ') {
      return 'SEZ';
    }

    // ✅ DEEMED EXPORT
    if (code === 'DEX') {
      return 'DEEMED EXPORT';
    }

    // ✅ B2B
    if (code === 'REG') {
      return 'B2B';
    }

    // ✅ COMPOSITION
    if (code === 'CMP') {
      return 'B2B-COMPOSITION';
    }

    // ✅ Default
    return 'B2C';
  }
  isIGSTApplicable(): boolean {

    const form = this.createOrderForm.value;

    const supplyType =
      String(form.supplyType || '').trim();

    // Warehouse State Code
    const fromStateCode =
      String(form.warehouseStateCode || '').trim();

    // Customer State Code
    let toStateCode = '';

    switch (supplyType) {

      case 'EXPORT':
      case 'DEEMED EXPORT':
        return true;

      case 'SEZ':

        // SEZ always IGST
        return true;

      case 'B2B':
      case 'B2B-COMPOSITION':

        toStateCode =
          String(
            form.BillToCustomerStateCode || ''
          ).trim();

        break;

      case 'B2C':

        toStateCode =
          String(
            form.ShipToCustomerStateCode ||
            form.BillToCustomerStateCode ||
            ''
          ).trim();

        break;

      default:
        return false;
    }

    if (!fromStateCode || !toStateCode) {
      return false;
    }

    // Interstate check
    return fromStateCode !== toStateCode;
  }

  getLUTLabel(): string {
    const type = this.createOrderForm.value.supplyType ?? '';

    const map: Record<string, string> = {
      EXPORT: 'Export under LUT (No GST)',
      SEZ: 'Supply to SEZ under LUT (No GST)'
    };

    return map[type] || 'Supply under LUT';
  }

  getExportType(): string {

    const form = this.createOrderForm.value;

    const type = form.supplyType;
    const isLUT = form.isLUT;

    if (type === 'EXPORT') {
      return isLUT ? 'EXPWOP' : 'EXPWP';
    }

    if (type === 'SEZ') {
      return isLUT ? 'SEZWOP' : 'SEZWP';
    }

    return '';
  }


  setExportType() {

    const form = this.createOrderForm.value;

    const type = form.supplyType;
    const isLUT = form.isLUT;

    let expTyp = '';

    if (type === 'EXPORT') {
      expTyp = isLUT ? 'EXPWOP' : 'EXPWP';
    } else if (type === 'SEZ') {
      expTyp = isLUT ? 'SEZWOP' : 'SEZWP';
    } else {
      expTyp = ''; // 🔥 CLEAR for non export types
    }

    this.createOrderForm.patchValue({
      expTyp: expTyp
    }, { emitEvent: false }); // 🔥 avoid loop
  }


  private exportTypeMap: Record<string, string> = {
    EXPWOP: 'Export without payment (LUT)',
    EXPWP: 'Export with payment',
    SEZWOP: 'SEZ without payment (LUT)',
    SEZWP: 'SEZ with payment'
  };
  getExportTypeLabel(): string {

    const type = this.createOrderForm.get('expTyp')?.value ?? '';

    return this.exportTypeMap[type] || '';
  }



  isExportOrSEZ(): boolean {
    const type = this.createOrderForm.value.supplyType;
    return type === 'EXPORT' || type === 'SEZ';
  }
  validateRCM() {
    const form = this.createOrderForm.value;

    if (form.isRCM && (form.supplyType === 'EXPORT' || form.supplyType === 'SEZ' || form.supplyType === 'B2C')) {

      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid RCM',
        detail: 'RCM not applicable for this supply type'
      });

      this.createOrderForm.patchValue({ isRCM: false });
    }
  }

  isRCMDisabled(): boolean {
    const type = this.createOrderForm.get('supplyType')?.value;

    return type != null && ['EXPORT', 'SEZ', 'B2C'].includes(type);
  }

  setPlaceOfSupply() {

    const form = this.createOrderForm.value;

    // ✅ EXPORT
    if (form.supplyType === 'EXPORT') {
      this.createOrderForm.patchValue({
        POSDisplay: 'Other Country',
        POS: '96'
      }, { emitEvent: false });
      return;
    }

    // ✅ B2B → ALWAYS BillTo (GST RULE)
    if (form.supplyType === 'B2B') {
      this.createOrderForm.patchValue({
        POSDisplay: form.BillToCustomerState || '',
        POS: form.BillToCustomerStateCode || ''
      }, { emitEvent: false });
      return;
    }

    // ✅ Others → ShipTo priority
    const posName = form.ShipToCustomerState || form.BillToCustomerState || '';
    const posCode = form.ShipToCustomerStateCode || form.BillToCustomerStateCode || '';

    this.createOrderForm.patchValue({
      POSDisplay: posName,
      POS: posCode
    }, { emitEvent: false });

    // console.log("BillToStateCode:", form.BillToCustomerStateCode);
    // console.log("ShipToStateCode:", form.ShipToCustomerStateCode);
  }



  updateRCMState(supplyType: string | null) {

    //console.log('Supply Type:', supplyType);

    const NON_RCM_TYPES = ['EXPORT', 'SEZ', 'B2C'];

    this.showRCM = !NON_RCM_TYPES.includes(supplyType ?? '');

    // console.log('showRCM:', this.showRCM);

    const rcm = this.createOrderForm.get('isRCM');

    if (!this.showRCM) {
      rcm?.setValue(false, { emitEvent: false });
      rcm?.disable({ emitEvent: false });
    } else {
      rcm?.enable({ emitEvent: false });
    }
  }

  currentFinancialYear: any;

  loadCurrentFinancialYear() {
    this.salesService.getCurrentFinancialYear().subscribe({
      next: (response: any) => {
        //console.log(response.data.fyName);

        if (!response.data) {

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            // detail: 'No open Financial Year found for current date.'
            detail: 'No Open Financial Year is available for the current date. Please contact your administrator.'
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createOrderForm.patchValue({
          FinancialYearId: this.currentFinancialYear.fyId
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No open Financial Year found.'
        });
      }
    });
  }

  validateFinancialYear(): boolean {

    const orderDate = this.createOrderForm.controls.orderDate.value;
    const requestedDate = this.createOrderForm.controls.requestedDate.value;
    //const requestedDate = this. returnSalesForm.controls.requestedDate.value;

    if (!orderDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Order Date is required.'
      });
      return false;
    }

    if (!requestedDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Requested Date is required.'
      });
      return false;
    }

    const fy = this.currentFinancialYear;

    if (!fy) {
      this.messageService.add({
        severity: 'error',
        summary: 'Financial Year',
        detail: 'No active Financial Year found.'
      });
      return false;
    }

    // Locked FY
    if (fy.status === 'Locked') {
      this.messageService.add({
        severity: 'error',
        summary: 'Locked Financial Year',
        detail: `Financial Year ${fy.fyName} is Locked.`
      });
      return false;
    }

    // Closed FY
    if (fy.status === 'Closed') {
      this.messageService.add({
        severity: 'error',
        summary: 'Closed Financial Year',
        detail: `Financial Year ${fy.fyName} is Closed.`
      });
      return false;
    }

    const startDate = new Date(fy.startDate);
    const endDate = new Date(fy.endDate);

    const vendiorPayment = new Date(orderDate);

    // Order Date validation
    if (vendiorPayment < startDate || vendiorPayment > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Order Date',
        detail: `Please select an Order Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    // Requested Date validation
    if (requestedDate) {
      const requested = new Date(requestedDate);

      if (requested < startDate || requested > endDate) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Requested Date',
          detail: `Please select a Requested Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
        });
        return false;
      }
    }

    return true;
  }

  formatDate(date: Date): string {

    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

  }

  onTransactionDateChange(date: Date, transaction: string) {
    // if (this.isInitializing) {
    //   return;
    // }
    if (!date) {
      this.currentFinancialYear = null;

      this.createOrderForm.patchValue({
        FinancialYearId: null
      });

      return;
    }

    this.salesService.getFinancialYearByDate(date).subscribe({
      next: (response: any) => {
        // console.log("Financial Year Response:", response);
        if (!response.success || !response.data) {

          this.currentFinancialYear = null;

          this.createOrderForm.patchValue({
            FinancialYearId: null
          });

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            detail: `No Open Financial Year found for the selected ${transaction} date.`
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createOrderForm.patchValue({
          FinancialYearId: response.data.fyId
        });
      },

      error: () => {

        this.currentFinancialYear = null;

        this.createOrderForm.patchValue({
          FinancialYearId: null
        });

        this.messageService.add({
          severity: 'error',
          summary: 'Financial Year',
          detail: 'Unable to fetch Financial Year.'
        });
      }
    });
  }

  getProjectLookup() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '80%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createOrderForm.patchValue({
          projectBoMId: data.projectBoMId,
          projectName: data.projectBoMName,
          projectNo: data.projectBoMCode
        });
      }
    });
  }

  clearProject() {
    this.createOrderForm.patchValue({
      projectBoMId: null,
      projectName: '',
      projectNo: ''
    });
  }


}